<template>
  <div class="fiche-formation">
    <div
      v-if="isLoading || isDiplomaActionPending"
      class="loading-overlay"
    >
      <div class="loading-overlay-content">
        <i class="fa fa-spinner fa-spin" />
        <span>{{ isLoading ? "Chargement de la formation..." : diplomaActionLoadingMessage }}</span>
      </div>
    </div>
    <va-modal
      class="modal"
      v-model="showFormation"
      cancelText="Annuler"
      okText="Enregistrer"
      max-width="100%"
      v-on:ok="saveFormation"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md4">
            <span style="color: blue"><b>Formation {{ formation.formation_type.name }} - Niveau {{
              formation.formation_type.niveau }}</b></span>
          </div>
          <div class="flex md6">

          </div>
          <div
            class="flex md2 "
            style="justify-content: flex-end; display: flex; align-items: center;"
          >
            <va-popover
              message="Modifier la formation"
              placement="left"
            >
              <va-button
                color="info"
                icon="fa fa-pencil"
                @click="updateFormation"
              >
                Modifier
              </va-button>
            </va-popover>
            <va-popover
              message="Supprimer la formation"
              placement="left"
            >
              <va-button
                color="danger"
                icon="fa fa-trash"
                small
                @click="deleteFormation"
                style="margin-left: 8px;"
              >
                Supprimer
              </va-button>
            </va-popover>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md6">
            <div class="row row-inside my-1">
              <div class="flex md1">
                <h1>Date:</h1>
              </div>
              <div class="flex md8">
                <span style="color: #808080; margin-right:10px;"><b> {{
                  moment(formation.date).format("DD/MM/YYYY")
                    }}</b></span>

                <va-button
                  :color="formation.formation_type.duree_salarie == hours_sa ? 'success' : 'warning'"
                  class="mx-3"
                  small
                >
                  Heures salariées : {{ hours_sa }} | Requis : {{ formation.formation_type.duree_salarie }}
                </va-button>
                <va-button
                  :color="formation.formation_type.duree_tns == hours_tns ? 'success' : 'warning'"
                  small
                >
                  Heures TNS : {{ hours_tns }} | Requis : {{ formation.formation_type.duree_tns }}
                </va-button>

              </div>

            </div>
            <div class="row row-inside">
              <div class="flex md1">
                <h1>TNS:</h1>
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Début matinée</label>
                <input type="time" step="900" v-model="TNSmatinDebSelect" :disabled="!tnsMatinAct || tnsSameAsSalarie" class="time-input" />
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Fin matinée</label>
                <input type="time" step="900" v-model="TNSmatinFinSelect" :disabled="!tnsMatinAct || tnsSameAsSalarie" class="time-input" />
              </div>
              <div class="flex md1 px-1">
                <va-popover
                  message="Formation le matin"
                  placement="left"
                >
                  <va-checkbox
                    label=""
                    v-model="tnsMatinAct"
                    :disabled="tnsSameAsSalarie"
                  /></va-popover>
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Début Après-Midi</label>
                <input type="time" step="900" v-model="TNSAMDebSelect" :disabled="!tnsAmAct || tnsSameAsSalarie" class="time-input" />
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Fin Après-Midi</label>
                <input type="time" step="900" v-model="TNSAMFinSelect" :disabled="!tnsAmAct || tnsSameAsSalarie" class="time-input" />
              </div>
              <div class="flex md1 px-1">
                <va-popover
                  message="Formation l'Après-Midi"
                  placement="left"
                >
                  <va-checkbox
                    label=""
                    v-model="tnsAmAct"
                    :disabled="tnsSameAsSalarie"
                  /></va-popover>
              </div>
              <div class="flex md1 px-1">
                <va-popover
                  message="TNS identique aux salariés"
                  placement="left"
                >
                  <va-checkbox
                    label="= Sal."
                    v-model="tnsSameAsSalarie"
                  />
                </va-popover>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md1">
                <h1>Salariés:</h1>
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Début matinée</label>
                <input type="time" step="900" v-model="SalmatinDebSelect" :disabled="!salMatinAct" class="time-input" />
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Fin matinée</label>
                <input type="time" step="900" v-model="SalmatinFinSelect" :disabled="!salMatinAct" class="time-input" />
              </div>
              <div class="flex md1 px-1">
                <va-popover
                  message="Formation le matin"
                  placement="left"
                >
                  <va-checkbox
                    label=""
                    v-model="salMatinAct"
                  /></va-popover>
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Début Après-Midi</label>
                <input type="time" step="900" v-model="SalAMDebSelect" :disabled="!salAmAct" class="time-input" />
              </div>
              <div class="flex md2 px-1">
                <label class="va-input__label">Fin Après-Midi</label>
                <input type="time" step="900" v-model="SalAMFinSelect" :disabled="!salAmAct" class="time-input" />
              </div>
              <div class="flex md2 px-1">
                <va-popover
                  message="Formation l'Après-Midi"
                  placement="left"
                >
                  <va-checkbox
                    label=""
                    v-model="salAmAct"
                  /></va-popover>
              </div>
            </div>
            <div class="row row-inside" style="justify-content: flex-end;">
              <div class="flex md3 px-1">
                <va-button
                  color="success"
                  icon="fa fa-save"
                  small
                  @click="saveHoraires"
                  :disabled="isSavingHoraires"
                >
                  Enregistrer les horaires
                </va-button>
              </div>
            </div>
          </div>
          <div class="flex md3">
            <div class="row row-inside mb-2">
              <div class="flex md12">

                <div class="row row-inside">
                  <div class="flex md10">
                    <h1 style="color: blue; ">{{ formation.inter ? 'Inter' : 'Intra' }}</h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12">
                <div class="row row-inside">
                  <div class="flex md12">
                    <h1>Salle:</h1>
                  </div>
                </div>
                <div class="row row-inside">

                  <div class="flex md10">
                    <span style="color: blue; font-size: 0.9em;">{{ formation.lieu.nom }}</br>
                      {{ formation.lieu.adresse.adresse }}
                      {{ formation.lieu.adresse.complement ? formation.lieu.adresse.complement  : '' }}
                      - {{ formation.lieu.adresse.code_postal + " " + formation.lieu.adresse.ville }}</span>
                  </div>

                </div>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12">
                <div class="row row-inside">
                  <div class="flex md12">
                    <h1>Formateur:</h1>
                  </div>
                </div>
                <div class="row row-inside">

                  <div class="flex md10">
                    <span style="color: blue; font-size: 0.9em;">{{ formation.formateur.nom }}
                      {{ formation.formateur.prenom }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="flex md3">
            <div class="row row-inside">
              <div class="flex md12">

                <va-popover
                  message="Salle réservée?"
                  placement="left"
                >
                  <va-checkbox
                    :label="reservationMessage"
                    v-model="reservationOk"
                  /></va-popover>

              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12">

                <va-popover
                  message="Feuille de présence"
                  placement="left"
                >
                  <va-checkbox
                    disabled
                    label="Feuille de présence générée"
                    v-model="tnsMatinAct"
                  /></va-popover>

              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md12">
                <va-popover
                  message="Générer les feuilles de présences"
                  placement="left"
                >
                  <va-button
                    color="info"
                    medium
                    @click="generateEmargement()"
                    icon="fa fa-plus"
                  /> Editer
                  les feuilles de présences

                </va-popover>
              </div>
              <div class="flex md12">
                <va-popover
                  message="Générer les diplômes des participants présents"
                  placement="left"
                >
                  <va-button
                    color="info"
                    medium
                    :disabled="!formation.pdfemargement"
                    @click="editDiplomas"
                    icon="fa fa-plus"
                  /> Editer
                  les dipômes
                </va-popover>
                <va-popover
                  message="Réinitialiser tous les diplômes de la formation"
                  placement="left"
                >
                  <va-button
                    color="warning"
                    medium
                    :disabled="isDiplomaActionPending || !formation.pdfemargement"
                    @click="resetAllDiplomas"
                    icon="fa fa-refresh"
                    style="margin-left: 8px;"
                  /> Réinitialiser les diplômes
                </va-popover>
              </div>
            </div>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md11"> <b>Entreprises</b></div>
          <div
            class="flex md1"
            v-if="formation.inter"
          >
            <va-popover
              message="Ajouter une entreprise"
              placement="left"
            >
              <va-button
                color="info"
                @click="showAddEntreprise = true"
                icon="fa fa-plus"
              >

              </va-button>
            </va-popover>
          </div>
          <div class="flex md12">
            <va-data-table
              class="va-table--hoverable va-table--stripped"
              :fields="fieldsEntreprises"
              :data="formation.entreprises"
              no-data-label="Aucune Entreprise Participante"
              :per-page="parseInt(perPage)"
            >
			<template slot="siren" slot-scope="props">
				<span>{{ props.rowData.siret.substring(0, 9) }}</span>
			</template>
              <template slot="actions" slot-scope="props">
                <va-popover
                  :message="getDiplomaEmailButtonMessage(props.rowData)"
                  placement="left"
                >
                  <span>
                    <va-button
                      size="small"
                      :color="getDiplomaEmailButtonColor(props.rowData)"
                      icon="fa fa-envelope"
                      :disabled="isDiplomaEmailButtonDisabled(props.rowData)"
                      @click.stop="sendDiplomaEmail(props.rowData)"
                    />
                  </span>
                </va-popover>
                <va-popover
                  :message="getDiplomaSentStatusButtonMessage(props.rowData)"
                  placement="left"
                >
                  <span>
                    <va-button
                      size="small"
                      :color="getDiplomaSentStatusButtonColor(props.rowData)"
                      icon="fa fa-check"
                      :disabled="isDiplomaSentStatusButtonDisabled(props.rowData)"
                      @click.stop="updateDiplomaSentStatus(props.rowData)"
                    />
                  </span>
                </va-popover>
                <va-button
                  size="small"
                  color="info"
                  :disabled="isDiplomaActionPending"
                  icon="fa fa-eye"
                  @click.stop="openEntreprise(props.rowData)"
                />
                <va-button
                  size="small"
                  color="danger"
                  :disabled="isDiplomaActionPending"
                  icon="fa fa-trash"
                  @click.stop="deleteEntreprise(props.rowData)"
                />
              </template>
            </va-data-table>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md10"><b> Participants</b></div>
          <div class="flex md2  ">
            <va-popover
              message="Feuilles de présences"
              placement="left"
            >Feuilles de présences
              <va-button
                :color="colorEmargement"
                icon="fa fa-file"
                @click="openEmargement()"
              >
              </va-button>

            </va-popover>
          </div>
          <div class="flex md12">
            <va-data-table
              class="va-table--hoverable va-table--stripped"
              :fields="fieldsParticipants"
              :data="participants"
              no-data-label="Aucun Participant"
              :per-page="parseInt(perPage)"
              @row-clicked="openParticipant"
              clickable
            >
              <template
                slot="presence"
                slot-scope="props"
              >
                <va-button
                  class="ma-0"
                  small
                  :color='props.rowData.presence? "success"
                  : "danger"'
                  @click="updatePresence(props.rowData)"
                >{{props.rowData.presence? "Présent" : "Absent"}}</va-button>

              </template>
              <template
                slot="diplome"
                slot-scope="props"
              >
			  <div class="row">
			  <div class="flex md6 ">
                <va-button
                  v-show="props.rowData.presence"
                  class="ma-0"
                  icon="fa fa-star"
                  :color='props.rowData.pdf? "success" : "danger"'
                  @click="getDiploma(props.rowData)"
                /></div>
				<div class="flex md6  ">
                <va-button
                  v-show="props.rowData.presence"
                  class="ma-0"
                  icon="fa fa-refresh"
                  color="warning"
                  :disabled="isDiplomaActionPending"
                  @click.stop="resetDiploma(props.rowData)"
                /></div></div>
              </template>
            </va-data-table>
          </div>
        </div>

      </div>
    </va-modal>
    <addEntreprise
      v-model="showAddEntreprise"
      :idformation="idformation"
      @idEntreprise="newEntreprise"
    />
    <ficheEntreprise
      v-model="showEntreprise"
      :identreprise="entrepriseSelect"
      :idformation="idformation"
      @updated="loadFormation"
    />

    <gestionFichesEmargement
      v-model="showEmargement"
      :idformation="idformation"
      v-on:uploaded="changeColorEmargement('success')"
      v-on:deleted="changeColorEmargement('info')"
    />

    <modifyFormation
      v-model="showModification"
      :idformation="idformation"
      @update="loadFormation"
    />

  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep } from "lodash";
import moment from "moment";
import addEntreprise from "./addEntreprise.vue";
import ficheEntreprise from "./fiche-entreprise.vue";
import gestionFichesEmargement from "./gestion-fiches-emargement.vue";
import modifyFormation from "./modify-formation.vue";

moment.locale("fr");

export default {
  name: 'FicheFormation',
  props: ["value", "idformation"],
  components: {
    addEntreprise,
    ficheEntreprise,
    gestionFichesEmargement,
    modifyFormation
  },
  data() {
    return {
      showModification: false,
      colorEmargement: "info",
      showEmargement: false,
      moment: moment,
      reservationMessage: "Salle réservée",
      reservationOk: false,
      reservationOld: false,
      participants: [],
      entrepriseSelect: "",
      isLoading: false,
      diplomaActionLoadingMessage: "Traitement en cours...",
      isSendingDiplomaEmail: false,
      isUpdatingDiplomaSentStatus: false,
      isResettingDiploma: false,
      isSavingHoraires: false,
      showEntreprise: false,
      perPage: 5,
      showFormation: false,
      showAddEntreprise: false,
      formation: {
        date: "",
        pdfemargement: false,
        formation_type: {
          name: "",
          niveau: ""
        },
        lieu: {
          adresse: {
            ville: ""
          }
        },
        formateur: {
          nom: "",
          prenom: ""
        },
        entreprises: [],

      },
      tnsMatinAct: true,
      tnsAmAct: true,
      salMatinAct: true,
      salAmAct: true,
      TNSmatinDebSelect: '',
      TNSmatinFinSelect: '',
      SalmatinDebSelect: '',
      SalmatinFinSelect: '',
      TNSAMDebSelect: '',
      TNSAMFinSelect: '',
      SalAMDebSelect: '',
      SalAMFinSelect: '',
      tnsSameAsSalarie: false,

    };
  },
  methods: {
    async saveHoraires() {
      this.isSavingHoraires = true;
      try {
        await axios.put("/api/afpf/formation-horaires", {
          idformation: this.idformation,
          TNSMatinBegin: this.tnsMatinAct && this.TNSmatinDebSelect ? this.TNSmatinDebSelect + ":00" : null,
          TNSMatinEnd:   this.tnsMatinAct && this.TNSmatinFinSelect ? this.TNSmatinFinSelect + ":00" : null,
          TNSApmBegin:   this.tnsAmAct    && this.TNSAMDebSelect    ? this.TNSAMDebSelect    + ":00" : null,
          TNSApmEnd:     this.tnsAmAct    && this.TNSAMFinSelect    ? this.TNSAMFinSelect    + ":00" : null,
          SalMatinBegin: this.salMatinAct && this.SalmatinDebSelect ? this.SalmatinDebSelect + ":00" : null,
          SalMatinEnd:   this.salMatinAct && this.SalmatinFinSelect ? this.SalmatinFinSelect + ":00" : null,
          SalApmBegin:   this.salAmAct    && this.SalAMDebSelect    ? this.SalAMDebSelect    + ":00" : null,
          SalApmEnd:     this.salAmAct    && this.SalAMFinSelect    ? this.SalAMFinSelect    + ":00" : null,
        });
        this.launchEpicmaxToast("Horaires enregistrés");
      } catch (error) {
        console.error(error);
        this.launchEpicmaxToast("Erreur lors de l'enregistrement des horaires");
      } finally {
        this.isSavingHoraires = false;
      }
    },
    syncTnsFromSalarie() {
      this.tnsMatinAct = this.salMatinAct;
      this.tnsAmAct = this.salAmAct;
      this.TNSmatinDebSelect = this.SalmatinDebSelect;
      this.TNSmatinFinSelect = this.SalmatinFinSelect;
      this.TNSAMDebSelect = this.SalAMDebSelect;
      this.TNSAMFinSelect = this.SalAMFinSelect;
    },
    resetValues() {
      this.formation = {
        date: "",
        pdfemargement: false,
        formation_type: { name: "", niveau: "" },
        lieu: { adresse: { ville: "" } },
        formateur: { nom: "", prenom: "" },
        entreprises: [],
      };
      this.participants = [];
      this.reservationOk = false;
      this.reservationOld = false;
      this.reservationMessage = "Salle réservée";
      this.colorEmargement = "info";
      this.tnsSameAsSalarie = false;
      this.tnsMatinAct = true;
      this.tnsAmAct = true;
      this.salMatinAct = true;
      this.salAmAct = true;
      this.TNSmatinDebSelect = '';
      this.TNSmatinFinSelect = '';
      this.SalmatinDebSelect = '';
      this.SalmatinFinSelect = '';
      this.TNSAMDebSelect = '';
      this.TNSAMFinSelect = '';
      this.SalAMDebSelect = '';
      this.SalAMFinSelect = '';
    },
    updateFormation() {
      this.showModification = true;
    },
    async deleteFormation() {
      if (!confirm("Supprimer cette formation ? Cette action est irréversible.")) {
        return;
      }
      try {
        await axios.delete("/api/afpf/formation", {
          params: { idformation: this.idformation },
        });
        this.launchEpicmaxToast("Formation supprimée");
        this.resetValues();
        this.$emit("deleted");
        this.$emit("close", false);
        this.$emit("input", false);
      } catch (error) {
        console.error(error);
        let errorMessage = "Erreur lors de la suppression de la formation";
        if (error.response) {
          switch (error.response.status) {
            case 400:
              errorMessage = "Erreur : paramètre manquant";
              break;
            case 403:
              errorMessage = error.response.data && error.response.data.message
                ? error.response.data.message
                : "Suppression impossible";
              break;
            case 404:
              errorMessage = "Formation introuvable";
              break;
            case 500:
              errorMessage = "Erreur serveur lors de la suppression";
              break;
          }
        }
        this.launchEpicmaxToast(errorMessage);
      }
    },
    getDiploma(participant) {
      console.log("getDiploma", participant);
 
        // Create diploma
        axios
          .post("/api/afpf/formation-diplome", {
            id_participation: participant.id_participation
          }, {
            responseType: "arraybuffer"
          })
          .then((response) => {
            this.downloadBlob(response.data, participant.nom + "_" + participant.prenom + "_" + this.formation.formation_type.shortname + "_Diplome.pdf");
            participant.pdf = true;
            this.launchEpicmaxToast("Diplôme généré et téléchargé");
          })
          .catch((error) => {
            console.error(error);
            this.launchEpicmaxToast("Erreur lors de la génération du diplôme");
          });
      
    },
    async editDiplomas() {
      if (!this.formation.pdfemargement) {
        this.launchEpicmaxToast("Veuillez d'abord téléverser la feuille de présence");
        return;
      }
      try {
        const response = await axios.post("/api/afpf/formation-diplomes-batch", {
          idformation: this.idformation,
        });
        const files = response.data && response.data.files ? response.data.files : [];
        const skipped = response.data && response.data.skipped ? response.data.skipped : [];
        files.forEach((fileInfo, index) => {
          const file = fileInfo && fileInfo.file ? fileInfo.file : null;
          if (!file) {
            return;
          }
          const entrepriseNom = fileInfo.entreprise_nom ? fileInfo.entreprise_nom : "Entreprise";
          const count = fileInfo.count ? fileInfo.count : 0;
          const fileName = "Diplomes_" + entrepriseNom + "_" + count + "_" + (index + 1) + ".pdf";
          this.downloadFile(file, fileName);
        });

        if (skipped.length > 0) {
          this.launchEpicmaxToast(skipped.length + " participants ignorés");
        } else {
          this.launchEpicmaxToast("Diplômes générés");
        }
      } catch (error) {
        console.error(error);
        this.launchEpicmaxToast("Erreur lors de la génération des diplômes");
      }
    },
    async resetDiploma(participant) {
      this.isResettingDiploma = true;
      try {
        await this.withDiplomaActionLoading("Réinitialisation du diplôme...", async () => {
          await axios.post("/api/afpf/reset-diploma", {
            id_participation: participant.id_participation,
          });
        });
        participant.pdf = false;
        this.launchEpicmaxToast("Diplôme réinitialisé");
      } catch (error) {
        console.error(error);
        this.launchEpicmaxToast("Erreur lors de la réinitialisation du diplôme");
      } finally {
        this.isResettingDiploma = false;
      }
    },
    async resetAllDiplomas() {
      this.isResettingDiploma = true;
      try {
        const response = await this.withDiplomaActionLoading("Réinitialisation des diplômes...", async () => {
          return await axios.post("/api/afpf/reset-diplomas", {
            idformation: this.idformation,
          });
        });
        const reset = response.data && response.data.reset ? response.data.reset : [];
        const skipped = response.data && response.data.skipped ? response.data.skipped : [];
        const resetIds = new Set(reset.map(r => r.id_participation));
        this.participants.forEach(p => {
          if (resetIds.has(p.id_participation)) {
            p.pdf = false;
          }
        });
        this.launchEpicmaxToast(reset.length + " diplôme(s) réinitialisé(s)" + (skipped.length > 0 ? ", " + skipped.length + " ignoré(s)" : ""));
      } catch (error) {
        console.error(error);
        this.launchEpicmaxToast("Erreur lors de la réinitialisation des diplômes");
      } finally {
        this.isResettingDiploma = false;
      }
    },
    updatePresence(participant) {
      console.log("updatePresence", participant);
      participant.presence = !participant.presence;
      axios
        .put("/api/afpf/formation-participation", {
          id_participation: participant.id_participation,
          presence: participant.presence
        })
        .then((response) => {
          this.launchEpicmaxToast("Présence mise à jour");
        })
        .catch((error) => {
          console.error(error);
          this.launchEpicmaxToast("Erreur lors de la mise à jour de la présence");
        });

    },
    openEmargement() {
      this.showEmargement = true;
    },
    changeColorEmargement(color) {
      this.colorEmargement = color;
    },
    downloadBlob(pdfData, name) {
      const blob = pdfData instanceof Blob
        ? pdfData
        : new Blob([pdfData], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      link.click();
      URL.revokeObjectURL(url);
    },
  async downloadFile(file, name) {
    try {
      const response = await axios.get('/api/single-file', { 
        params: { file: file },
        responseType: "blob" 
      });
      this.downloadBlob(response.data, name);
    } catch (error) {
      console.error("Error downloading file:", error);
      this.launchEpicmaxToast("Erreur lors du téléchargement du fichier");
    }

  },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    async generateEmargement() {
      console.log("generateEmargement");
      let res = await axios.post("/api/afpf/formation-emargement", {
        idformation: this.idformation
      });
      this.downloadItem(res.data.url, moment(this.formation.date).format('YYYY-MM') + 'FEUILLE_DE_PRESENCE.pdf');
      console.log("generateEmargement", res.data);

    },
    openParticipant(row) {
      console.log("openParticipant", row);
      //  this.participantSelect = row.id;
      //  this.showParticipant = true;
    },
    async newEntreprise(value) {
      console.log("newEntreprise", value);
      let res = await axios.get("/api/entreprise-infos", {
        params: { id: value },
      });
      let entreprise = res.data;
      console.log("newEntreprise2", entreprise);
      //  entreprise.siret = entreprise.etablissement.siret;
      entreprise.contact = entreprise.etablissement.contact.titre + " " + entreprise.etablissement.contact.nom + " " + entreprise.etablissement.contact.prenom;
      entreprise.ville = entreprise.etablissement.adress.ville;
      entreprise.cp = entreprise.etablissement.adress.code_postal;
      console.log("newEntreprise2", entreprise);
      this.formation.entreprises.push(entreprise);
    },
    openEntreprise(row) {
      console.log("openEntreprise", row);
      this.entrepriseSelect = row.identreprise;
      this.showEntreprise = true;
    },
    getEntrepriseDiplomaSentStatus(entreprise) {
      return entreprise && entreprise.participation
        ? Number(entreprise.participation.diploma_sent)
        : 0;
    },
    getDiplomaEmailButtonColor(entreprise) {
      const diplomaSent = this.getEntrepriseDiplomaSentStatus(entreprise);

      return diplomaSent === 1 ? "success" : "info";
    },
    getDiplomaEmailButtonMessage(entreprise) {
      if (!this.formation.pdfemargement) {
        return "Téléverser la feuille de présence d'abord";
      }

      if (!entreprise.recipientEmail) {
        return "Aucune adresse email de destinataire";
      }

      const diplomaSent = this.getEntrepriseDiplomaSentStatus(entreprise);

      return diplomaSent === 1 ? "Diplômes déjà envoyés" : "Envoyer les diplômes";
    },
    isDiplomaEmailButtonDisabled(entreprise) {
      return this.isDiplomaActionPending || !this.formation.pdfemargement || !entreprise.recipientEmail;
    },
    getDiplomaSentStatusButtonColor(entreprise) {
      const diplomaSent = this.getEntrepriseDiplomaSentStatus(entreprise);

      return diplomaSent === 1 ? "success" : "info";
    },
    getDiplomaSentStatusButtonMessage(entreprise) {
      if (!this.formation.pdfemargement) {
        return "Téléverser la feuille de présence d'abord";
      }

      const diplomaSent = this.getEntrepriseDiplomaSentStatus(entreprise);

      return diplomaSent === 1
        ? "Marquer les diplômes comme non envoyés"
        : "Marquer les diplômes comme envoyés";
    },
    isDiplomaSentStatusButtonDisabled() {
      return this.isDiplomaActionPending || !this.formation.pdfemargement;
    },
    ensureEntrepriseParticipation(entreprise) {
      if (!entreprise.participation) {
        entreprise.participation = {};
      }

      return entreprise.participation;
    },
    async withDiplomaActionLoading(message, action) {
      this.diplomaActionLoadingMessage = message;
      const loadingStart = Date.now();

      try {
        return await action();
      } finally {
        const minVisibleDuration = 500;
        const elapsed = Date.now() - loadingStart;
        if (elapsed < minVisibleDuration) {
          await new Promise((resolve) => setTimeout(resolve, minVisibleDuration - elapsed));
        }
        this.diplomaActionLoadingMessage = "Traitement en cours...";
      }
    },
    async sendDiplomaEmail(entreprise) {
      if (!entreprise || !entreprise.identreprise) {
        this.launchEpicmaxToast("Entreprise invalide");
        return;
      }

      if (!this.formation.pdfemargement) {
        this.launchEpicmaxToast("Veuillez d'abord téléverser la feuille de présence");
        return;
      }

      if (!entreprise.recipientEmail) {
        this.launchEpicmaxToast("Aucune adresse email de destinataire");
        return;
      }

      this.isSendingDiplomaEmail = true;
      try {
        await this.withDiplomaActionLoading("Envoi des diplômes en cours...", async () => {
          await axios.post("/api/afpf/send-diploma-email", {
            idformation: this.idformation,
            identreprise: entreprise.identreprise,
          });
        });
        this.ensureEntrepriseParticipation(entreprise).diploma_sent = 1;
        this.launchEpicmaxToast("Diplôme envoyé à " + entreprise.nom);
      } catch (error) {
        console.log(error);
        let errorMessage = "Erreur lors de l'envoi du diplôme";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.launchEpicmaxToast(errorMessage);
      } finally {
        this.isSendingDiplomaEmail = false;
      }
    },
    async updateDiplomaSentStatus(entreprise) {
      if (!entreprise || !entreprise.identreprise) {
        this.launchEpicmaxToast("Entreprise invalide");
        return;
      }

      if (!this.formation.pdfemargement) {
        this.launchEpicmaxToast("Veuillez d'abord téléverser la feuille de présence");
        return;
      }

      const participation = this.ensureEntrepriseParticipation(entreprise);
      if (!participation.idfpe) {
        this.launchEpicmaxToast("Participation entreprise introuvable");
        return;
      }

      const diplomaSent = this.getEntrepriseDiplomaSentStatus(entreprise) === 1 ? 0 : 1;

      this.isUpdatingDiplomaSentStatus = true;
      try {
        await this.withDiplomaActionLoading("Mise à jour du statut des diplômes...", async () => {
          await axios.patch("/api/afpf/diploma-sent-status", {
            idfpe: participation.idfpe,
            diploma_sent: diplomaSent,
          });
        });
        participation.diploma_sent = diplomaSent;
        this.launchEpicmaxToast(
          diplomaSent === 1
            ? "Statut des diplômes mis à envoyé"
            : "Statut des diplômes remis à non envoyé"
        );
      } catch (error) {
        console.log(error);
        let errorMessage = "Erreur lors de la mise à jour du statut des diplômes";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.launchEpicmaxToast(errorMessage);
      } finally {
        this.isUpdatingDiplomaSentStatus = false;
      }
    },
    async deleteEntreprise(entreprise) {
      try {
        await axios.delete("/api/afpf/remove-entreprise-from-formation", {
          data: {
            idformation: this.idformation,
            identreprise: entreprise.identreprise
          }
        });
        // Remove from list on success
        const index = this.formation.entreprises.findIndex(e => e.identreprise === entreprise.identreprise);
        if (index > -1) {
          this.formation.entreprises.splice(index, 1);
        }
        this.launchEpicmaxToast("Entreprise supprimée avec succès");
      } catch (error) {
        console.log(error);
        let errorMessage = "Erreur lors de la suppression de l'entreprise";
        
        if (error.response) {
          switch (error.response.status) {
            case 400:
              errorMessage = "Erreur : paramètres manquants";
              break;
            case 403:
              errorMessage = "Impossible de supprimer : la date est passée, la feuille de présence a été uploadée ou des diplômes ont été générés";
              break;
            case 404:
              errorMessage = "Erreur : formation ou participation entreprise non trouvée";
              break;
            case 500:
              errorMessage = "Erreur serveur lors de la suppression";
              break;
            default:
              errorMessage = error.response.data && error.response.data.message ? error.response.data.message : errorMessage;
          }
        }
        this.launchEpicmaxToast(errorMessage);
      }
    },

    loadHorairesFormation: function () {
      if (this.formation.horaires) {
        const h = this.formation.horaires;
        this.tnsMatinAct = !!h.TNSMatinBegin;
        this.tnsAmAct = !!h.TNSApmBegin;
        this.salMatinAct = !!h.SalMatinBegin;
        this.salAmAct = !!h.SalApmBegin;
        this.TNSmatinDebSelect = h.TNSMatinBegin ? moment(h.TNSMatinBegin, "HH:mm:ss").format("HH:mm") : '';
        this.TNSmatinFinSelect = h.TNSMatinEnd ? moment(h.TNSMatinEnd, "HH:mm:ss").format("HH:mm") : '';
        this.TNSAMDebSelect = h.TNSApmBegin ? moment(h.TNSApmBegin, "HH:mm:ss").format("HH:mm") : '';
        this.TNSAMFinSelect = h.TNSApmEnd ? moment(h.TNSApmEnd, "HH:mm:ss").format("HH:mm") : '';
        this.SalmatinDebSelect = h.SalMatinBegin ? moment(h.SalMatinBegin, "HH:mm:ss").format("HH:mm") : '';
        this.SalmatinFinSelect = h.SalMatinEnd ? moment(h.SalMatinEnd, "HH:mm:ss").format("HH:mm") : '';
        this.SalAMDebSelect = h.SalApmBegin ? moment(h.SalApmBegin, "HH:mm:ss").format("HH:mm") : '';
        this.SalAMFinSelect = h.SalApmEnd ? moment(h.SalApmEnd, "HH:mm:ss").format("HH:mm") : '';
      }
    },
    async loadFormation() {
      this.isLoading = true;
      try {
        if (!this.idformation) {
          this.launchEpicmaxToast("Aucune formation séléctionnée");
          this.$emit("close", false);
          this.$emit("input", false);
          return;
        }

        let resTmp = await axios.get("/api/afpf/formation", {
          params: { idformation: this.idformation },
        });

        this.formation = cloneDeep(resTmp.data);
        this.participants = this.formation.participants;
        this.participants.forEach((p) => {
          p.presence = p.presence ? true : false;
          p.pdf = p.pdf ? true : false;
        });

        this.colorEmargement = this.formation.pdfemargement ? "success" : "info";

        this.loadHorairesFormation();

        if (this.formation.reservations.length > 0) {
          if (this.formation.reservations[0].reservation) {
            this.reservationOk = true;
            this.reservationOld = true;
            this.reservationMessage = "Salle réservée par " + this.formation.reservations[0].userName + " le " + moment(this.formation.reservations[0].timestamp).format("DD/MM/YYYY");
          } else {
            this.reservationMessage = "Salle réservée";
            this.reservationOk = false;
            this.reservationOld = false;
          }
        } else {
          this.reservationMessage = "Salle réservée";
          this.reservationOk = false;
          this.reservationOld = false;
        }


        console.log("loadFormation", this.formation);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement de la formation");
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.resetValues();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    async saveFormation() {
      try {
        this.formation.horaires.TNSMatinBegin = this.tnsMatinAct && this.TNSmatinDebSelect ? this.TNSmatinDebSelect + ":00" : null;
        this.formation.horaires.TNSMatinEnd   = this.tnsMatinAct && this.TNSmatinFinSelect ? this.TNSmatinFinSelect + ":00" : null;
        this.formation.horaires.TNSApmBegin   = this.tnsAmAct    && this.TNSAMDebSelect    ? this.TNSAMDebSelect    + ":00" : null;
        this.formation.horaires.TNSApmEnd     = this.tnsAmAct    && this.TNSAMFinSelect    ? this.TNSAMFinSelect    + ":00" : null;
        this.formation.horaires.SalMatinBegin = this.salMatinAct && this.SalmatinDebSelect ? this.SalmatinDebSelect + ":00" : null;
        this.formation.horaires.SalMatinEnd   = this.salMatinAct && this.SalmatinFinSelect ? this.SalmatinFinSelect + ":00" : null;
        this.formation.horaires.SalApmBegin   = this.salAmAct    && this.SalAMDebSelect    ? this.SalAMDebSelect    + ":00" : null;
        this.formation.horaires.SalApmEnd     = this.salAmAct    && this.SalAMFinSelect    ? this.SalAMFinSelect    + ":00" : null;

        if (this.reservationOk !== this.reservationOld) {
          let reservationNew = {
            idformation: this.formation.idformation,
            reservation: this.reservationOk,
          };
          this.formation.reservationNew = reservationNew;
        }

        let res = await axios.put("/api/afpf/formation", this.formation);
        this.launchEpicmaxToast("Formation enregistrée");

        this.$emit("close", false);
        this.$emit("input", false);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'enregistrement de la formation");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    isDiplomaActionPending() {
      return this.isSendingDiplomaEmail || this.isUpdatingDiplomaSentStatus || this.isResettingDiploma;
    },
    hours_sa() {
      let hours = 0;
      if (this.salMatinAct && this.SalmatinDebSelect && this.SalmatinFinSelect) {
        hours += moment.duration(moment(this.SalmatinFinSelect, "HH:mm").diff(moment(this.SalmatinDebSelect, "HH:mm"))).asHours();
      }
      if (this.salAmAct && this.SalAMDebSelect && this.SalAMFinSelect) {
        hours += moment.duration(moment(this.SalAMFinSelect, "HH:mm").diff(moment(this.SalAMDebSelect, "HH:mm"))).asHours();
      }
      return hours;
    },
    hours_tns() {
      let hours = 0;
      if (this.tnsMatinAct && this.TNSmatinDebSelect && this.TNSmatinFinSelect) {
        hours += moment.duration(moment(this.TNSmatinFinSelect, "HH:mm").diff(moment(this.TNSmatinDebSelect, "HH:mm"))).asHours();
      }
      if (this.tnsAmAct && this.TNSAMDebSelect && this.TNSAMFinSelect) {
        hours += moment.duration(moment(this.TNSAMFinSelect, "HH:mm").diff(moment(this.TNSAMDebSelect, "HH:mm"))).asHours();
      }
      return hours;
    },

    fieldsEntreprises() {
      return [
        {
          name: "__slot:siren",
          title: "SIREN",
          sortField: "siret",
          width: "10%",
        },
        {
          name: "nom",
          title: "Nom",
          sortField: "nom",
          width: "20%",
        },
        {
          name: "contact",
          title: "Gérant",
          sortField: "contact",
          width: "20%",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "15%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal",
          width: "5%",
        },
		        {
          name: "recipientEmail",
          title: "Email diplômes",
          sortField: "recipientEmail",
          width: "15%",
        },
        {
          name: "__slot:actions",
          title: "Actions",
          width: "15%",
        },
      ];
    },
    fieldsParticipants() {
      return [
        {
          name: "titre",
          title: "Titre",
          sortField: "titre",
          width: "10%",
        },
        {
          name: "nom",
          title: "Nom",
          sortField: "nom",
          width: "20%",
        },
        {
          name: "prenom",
          title: "Prénom",
          sortField: "prenom",
          width: "20%",
        },
        {
          name: "nomEntreprise",
          title: "Entreprise",
          sortField: "nomEntreprise",
          width: "20%",
        },
        {
          name: "statut",
          title: "Statut",
          sortField: "statut",
          width: "15%",
        },
        {
          name: "__slot:presence",
          title: "Présence",
          width: "10%",
        }, {
          name: "__slot:diplome",
          title: "Diplôme",
          width: "15%",
        },
      ];
    }
  },
  mounted() {
    this.showFormation = this.value;
  },
  watch: {
    tnsAmAct() {
      if (!this.tnsAmAct) {
        this.TNSAMDebSelect = '';
        this.TNSAMFinSelect = '';
      } else {
        this.TNSAMDebSelect = '13:30';
        this.TNSAMFinSelect = '17:30';
      }
    },
    tnsMatinAct() {
      if (!this.tnsMatinAct) {
        this.TNSmatinDebSelect = '';
        this.TNSmatinFinSelect = '';
      } else {
        this.TNSmatinDebSelect = '08:30';
        this.TNSmatinFinSelect = '12:00';
      }
    },
    salAmAct() {
      if (!this.salAmAct) {
        this.SalAMDebSelect = '';
        this.SalAMFinSelect = '';
      } else {
        this.SalAMDebSelect = '13:30';
        this.SalAMFinSelect = '17:30';
      }
      if (this.tnsSameAsSalarie) this.syncTnsFromSalarie();
    },
    salMatinAct() {
      if (!this.salMatinAct) {
        this.SalmatinDebSelect = '';
        this.SalmatinFinSelect = '';
      } else {
        this.SalmatinDebSelect = '08:30';
        this.SalmatinFinSelect = '12:00';
      }
      if (this.tnsSameAsSalarie) this.syncTnsFromSalarie();
    },
    SalmatinDebSelect() { if (this.tnsSameAsSalarie) this.syncTnsFromSalarie(); },
    SalmatinFinSelect() { if (this.tnsSameAsSalarie) this.syncTnsFromSalarie(); },
    SalAMDebSelect() { if (this.tnsSameAsSalarie) this.syncTnsFromSalarie(); },
    SalAMFinSelect() { if (this.tnsSameAsSalarie) this.syncTnsFromSalarie(); },
    tnsSameAsSalarie(val) {
      if (val) this.syncTnsFromSalarie();
    },
    value() {
      this.showFormation = this.value;
      if (this.value) {
        this.resetValues();
        this.loadFormation();
      }
    },
  },
};
</script>

<style scoped>
.fiche-formation {
  /* Add your component styles here */
  position: relative;
}

.forcewidth {
  width: 80vw;
  height: 80vh;
  overflow: auto;
}

.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.loading-overlay-content {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 12px 16px;
  color: #2c3e50;
  font-weight: 600;
}

.time-input {
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 0.9em;
  color: #2c3e50;
}

.time-input:disabled {
  background: #f5f5f5;
  color: #aaa;
  cursor: not-allowed;
}
</style>
